import {
    ConnectedProps,
    connectExpressCheckout,
} from './connectExpressCheckout';
import { ExpressCheckout, ExpressCheckoutProps } from './ExpressCheckout';

export type ConnectedExpressCheckoutProps = Omit<
    ExpressCheckoutProps,
    keyof ConnectedProps
>;
const ConnectedExpressCheckout = connectExpressCheckout(ExpressCheckout);

export default ConnectedExpressCheckout;
